import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';
import { IManualEventOverrides } from '@faire/web--source/common/pete/types';

export const eventKey = 'infra-uplt-timing';

/**
 * User Perceived Load Timing v1.1

https://docs.google.com/document/d/1qTlLrJ9_0AjTzyBW7_VxuTPU-Ae-zMy7cOeFo7A-4y4/edit?ouid=116306193541169001832&usp=docs_home&ths=true&dl=CgYKBAgCEAE.
 */
export function trackInfraUpltTiming(
  name: string,
  load_type2: string,
  status3: string,
  manualOverrides?: IManualEventOverrides
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    manualOverrides,
    parameters: { name, load_type2, status3 },
  });
}

/**
 * Trace for event: infra-uplt-timing
 */
export function trackInfraUpltTimingTracePageLoaded(
  name: string = '',
  load_type2: string = '',
  status3: string = '',
  traceId4: string = '',
  errors_Custom5: string = '',
  sourceEventMarker?: ITraceEventMarker,
  manualOverrides?: IManualEventOverrides
): void {
  trackClientEvent({
    eventKey: 'infra-uplt-timing-trace-page_loaded',
    realTimeTracking: false,
    manualOverrides,
    sourceEventKey: 'infra-uplt-timing',
    sourceEventMarker,
    parameters: { name, load_type2, status3, traceId4, errors_Custom5 },
  });
}

/**
 * Trace for event: infra-uplt-timing
 */
export function trackInfraUpltTimingTracePageReady(
  name: string = '',
  load_type2: string = '',
  status3: string = '',
  traceId4: string = '',
  sourceEventMarker?: ITraceEventMarker,
  manualOverrides?: IManualEventOverrides
): void {
  trackClientEvent({
    eventKey: 'infra-uplt-timing-trace-page_ready',
    realTimeTracking: false,
    manualOverrides,
    sourceEventKey: 'infra-uplt-timing',
    sourceEventMarker,
    parameters: { name, load_type2, status3, traceId4 },
  });
}

/**
 * Trace for event: infra-uplt-timing
 */
export function trackInfraUpltTimingTraceUserInteractions(
  interactions: string = '',
  start_of_tracking2: string = '',
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'infra-uplt-timing-trace-user_interactions',
    realTimeTracking: false,
    sourceEventKey: 'infra-uplt-timing',
    sourceEventMarker,
    parameters: { interactions, start_of_tracking2 },
  });
}
